import { RouterState } from "@ngrx/router-store";
import { Auth } from "../../auth/primitives/auth";
import { generateUUID } from "three/src/math/MathUtils.js";
import {User} from "../../auth/primitives/user";

export interface AuthState {
  userAvatarId: string,
  auth: Auth;
  user: User;
  httpEventLoading: boolean;
  httpError: Error;
  routerState: RouterState;
  authReady: boolean;
  isGuest: boolean;
}

export const initialState: AuthState = {
  userAvatarId: generateUUID(),
  auth: null,
  user: null,
  httpEventLoading: false,
  httpError: null,
  routerState: null,
  authReady: false,
  isGuest: true,
};
